import {
    Component,
    OnInit,
    OnDestroy,
    QueryList,
    ViewChildren,
    AfterViewInit
} from '@angular/core';
import { AppConfigService } from '@core/services/config.service';
import {
    FormGroup,
    FormBuilder,
    Validators,
    FormArray,
    FormArrayName,
    FormGroupName,
    FormControl
} from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material';
import { AppConfirmDialogComponent } from '@core/components/confirm-dialog/confirm-dialog.component';
import { LocalService } from '../local.services';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Local } from '@core/models/local.model';
import { ScrollService } from '../scroll.services';
import { AppPopOverStepsComponent } from '../popover/popover.component';
import { AppAlertDialogComponent } from '@core/components/alert/alert-dialog.component';
import { ProgressService } from '../probress-steps/progress.services';
import { AppValidate } from '../validate';
import { ToastrService } from 'ngx-toastr';
export interface Owner {
    name: string;
    lastname: string;
    email: string;
    phone: string;
    document: number;
    fiscal_address: string;
    percentage_participation: string;
}
@Component({
    selector: 'app-register-step-4',
    templateUrl: './step4.component.html',
    styleUrls: ['./step4.component.scss']
})
export class AppStep4Component implements OnInit, AfterViewInit,  OnDestroy {
    local_id: any;
    confirmDialogRef: MatDialogRef<AppConfirmDialogComponent>;
    alertDialogRef: MatDialogRef<AppAlertDialogComponent>;
    value = 0;
    loading = false;
    regForm: FormGroup;
    regFormErrors: any;
    local: Local;
    private _unsubscribeAll: Subject<any>;
    @ViewChildren(AppPopOverStepsComponent) popovers: QueryList<
        AppPopOverStepsComponent
    >;

    constructor(
        private appConfig: AppConfigService,
        private activatedRoute: ActivatedRoute,
        private _formBuilder: FormBuilder,
        private _router: Router,
        private _toastr: ToastrService,
        public dialog: MatDialog,
        private _scrollService: ScrollService,
        private _progressService: ProgressService,
        private _localService: LocalService
    ) {
        this.appConfig.setSettings({
            layout: {
                navigation: 'left',
                toolbar: 'above',
                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer: {
                    home: false,
                    register: true,
                    fixed: true
                }
            }
        });
        this.local = new Local();
        this._unsubscribeAll = new Subject();

        this.regFormErrors = {
            email: {}
        };
    }

    add() {
        const data: any[] = this.getRawValueOwners();
        const percent = this.calcularPercent(data);
        if (percent < 100) {
            this.createOwners();
        } else {
            this.alert('No puedes agregar más propietarios si tienes el 100%');
        }
    }

    createOwners() {
        const owners = this.createForm();
        this.owners.push(owners);
        this.handleOwnersChanges();
    }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(queryParams => {
            this.activatedRoute.params.subscribe(routeParams => {
                this.local_id = routeParams.id;
            });
        });

        this.regForm = this._formBuilder.group({
            owners: this._formBuilder.array([this.createForm()])
        });
        this.regForm.valueChanges.subscribe(res => {
            const controls = <FormArray>(
                this.regForm.controls['owners']['controls']
            );
            Object.keys(controls).forEach(key => {
                const control = <FormControl>(
                    this.regForm.controls['owners']['controls'][key]
                );

                this.value = control.get('percentage_participation').value;
            });
        });

        this._localService.localOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(local => {
                this.local = new Local(local);

                if (this.local.owner_leads.length > 0) {
                    const owner_leads = this.local.owner_leads;
                    owner_leads.map(async (val, key) => {
                        if (key !== 0) {
                            this.createOwners();
                            await this.addFormValue(key, val);
                        } else {
                            await this.addFormValue(key, val);
                        }
                    });
                } else {
                    const control = <FormControl>(
                        this.regForm.controls['owners']['controls'][0]
                    );
                    control.patchValue({
                        name: this.local.contact_name,
                        lastname: this.local.contact_lastname,
                        email: this.local.contact_email,
                        phone: this.local.contact_phone
                    });
                }
            });
        this.handleOwnersChanges();
    }
    ngAfterViewInit() {
        this._scrollService._init();
    }
    updatePercentInput(key) {
        const control = <FormControl>(
            this.regForm.controls['owners']['controls'][key]
        );
        if (control) {
            control.get('percentage_participation').setValue(100);
        }
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            name: [''],
            lastname: [''],
            email: [''],
            phone: [''],
            document: [''],
            fiscal_address: [''],
            percentage_participation: ['']
        });
    }
    get owners(): FormArray {
        return this.regForm.get('owners') as FormArray;
    }

    toggle(index): void {
        this.popovers.forEach((pop: AppPopOverStepsComponent) => {
            if (pop.index === index) {
                pop.open = !!pop.open;
            } else {
                pop.open = false;
            }
        });
    }
    validateLengthControl(control: FormControl, key): boolean {
        const _value: string = control.get(key).value;

        if (_value === null) {
            return false;
        }

        return _value.length > 0 ? true : false;
    }

    validateEmptyControls(): boolean {
        let status = false;
        const controls = <FormArray>this.regForm.controls['owners']['controls'];
        Object.keys(controls).forEach(key => {
            const control = <FormControl>(
                this.regForm.controls['owners']['controls'][key]
            );
            const value = control.value;

            if (value.document === null || value.document === '') {
                status =  true;
            }

            if (value.email === null || value.email === '')  {
                status =  true;
            }

            if (value.fiscal_address === null || value.fiscal_address === '')  {
                status =  true;
            }
            if (value.lastname === null || value.lastname === '')  {
                status =  true;
            }

            if (value.name === null || value.name === '')  {
                status =  true;
            }

            if (value.percentage_participation === null || value.percentage_participation === '')  {
                status =  true;
            }

            if (value.phone === null || value.phone === '')  {
                status =  true;
            }

        });
        return status;

    }

    onSubmit() {

            this.loading = true;
            const data: any[] = this.getRawValueOwners();

            const percent = this.calcularPercent(data);

            if (percent > 100) {
                this.loading = false;
                this.alert('El porcentaje no debe ser mayor a 100%');
                return;
            }
            const _values: any = {
                data: data
            };
            const result = this.validateEmptyControls();
            if (!result) {
                _values.steps = this._progressService.getCurrentIndex(4);
            } else {
                _values.steps = this._progressService.removeCurrentIndex(4);
            }

            if (data.length > 0) {
                this._localService
                    .addOwnerLead(_values)
                    .then((res: any) => {
                        this.loading = false;
                        this._router.navigate([
                            `/local/registro/5/${this.local_id}`
                        ]);
                    })
                    .catch((error: any) => {
                        this._toastr.error('Ocurrió un error, inténtalo nuevamente.');
                        this.loading = false;
                    });
            } else {
                this._router.navigate([`/local/registro/5/${this.local_id}`]);
            }

    }
    private emptyValues(value: any) {
        return (
            value.document !== '' ||
            value.email !== '' ||
            value.fiscal_address !== '' ||
            value.lastname !== '' ||
            value.name !== '' ||
            value.percentage_participation !== '' ||
            value.phone !== ''
        );
    }
    getRawValueOwners() {
        const temp: any[] = [];
        const controls = <FormArray>this.regForm.controls['owners']['controls'];
        Object.keys(controls).forEach(key => {
            const control = <FormControl>(
                this.regForm.controls['owners']['controls'][key]
            );
            const value = control.value;

            if (this.emptyValues(value)) {
                temp.push(value);
            }
        });
        return temp;
    }
    calcularPercent(data: any[]) {
        let r = 0;
        data.map((item: any) => {
            r += Number(item.percentage_participation);
        });
        return r;
    }

    addFormValue(key, val: any) {
        const control = <FormControl>(
            this.regForm.controls['owners']['controls'][key]
        );
        control.patchValue(val);
    }
    patchFormValue() {
        const controls = <FormArray>this.regForm.controls['owners']['controls'];
        Object.keys(controls).forEach(key => {
            const control = <FormControl>(
                this.regForm.controls['owners']['controls'][key]
            );
            control.patchValue({
                name: '',
                lastname: '',
                email: '',
                phone: '',
                percentage_participation: ''
            });
        });
    }

    remove(i) {
        this.confirmDialogRef = this.dialog.open(AppConfirmDialogComponent, {
            disableClose: true
        });
        this.confirmDialogRef.componentInstance.subtitle = false;
        this.confirmDialogRef.componentInstance.messageButton = 'Aceptar';

        this.confirmDialogRef.componentInstance.confirmMessage =
            'eliminar este propietario';

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (!!Boolean(result)) {
                const controls = <FormArray>this.regForm.controls['owners'];
                controls.removeAt(i);

                const data: any[] = this.regForm.get('owners').value;
                this._localService
                    .addOwnerLead({ data: data, steps: this._progressService.getCurrentIndex(4) })
                    .then((res: any) => {
                        if (data.length === 1) {
                            this.updatePercentInput(0);
                        }
                    }).catch((err: any) => {
                        this._toastr.error('Ocurrió un error, inténtalo nuevamente.');
                    });

            }
            this.confirmDialogRef = null;
        });
    }
    numUpdown(e: number, i) {
        const controls = <FormArray>this.regForm.controls['owners']['controls'];
        Object.keys(controls).forEach(key => {
            const control = <FormControl>(
                this.regForm.controls['owners']['controls'][key]
            );
            if (Number(key) === i) {
                control.patchValue({
                    percentage_participation: e
                });
            }
        });
    }
    handleOwnersChanges(): void {

        const controls = <FormArray>this.regForm.controls['owners']['controls'];
        Object.keys(controls).forEach(key => {
            const control = <FormControl>(
                this.regForm.controls['owners']['controls'][key]
            );
            AppValidate.Email(<FormControl>control.get('email'));
            AppValidate.Number(<FormControl>control.get('phone'));
            AppValidate.DNI(<FormControl>control.get('document'));
            AppValidate.Percent(<FormControl>(
                control.get('percentage_participation')
            ));
        });
    }

    prev() {
        const flag_owner_place = Number(this.local.flag_owner_place);

        if (flag_owner_place === 1) {
            this._router.navigate([`/local/registro/2/${this.local_id}`]);
        } else {
            this._router.navigate([`/local/registro/3/${this.local_id}`]);
        }
    }

    skip() {
        this._router.navigate([`/local/registro/5/${this.local_id}`]);
    }
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    alert(msg: string) {
        this.alertDialogRef = this.dialog.open(AppAlertDialogComponent, {
            disableClose: false
        });
        this.alertDialogRef.componentInstance.alertMessage = msg;
        this.alertDialogRef.afterClosed().subscribe(result => {
            this.alertDialogRef = null;
        });
    }
}
